import React from "react";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";

/**
 * Renderiza o componente NumericFormatCustom.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {string} props.name - Nome usado pelo campo controlado.
 * @param {Function} props.onChange - Callback executado quando o valor é alterado.
 * @param {*} props.other - Propriedade `other` do componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      valueIsNumericString
      allowLeadingZeros
      allowNegative
      allowedDecimalSeparators={["."]}
      decimalSeparator=","
      fixedDecimalScale
    />
  );
});

NumericFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NumericFormatCustom;
